import { TkSearchFormListItem } from "../../type/componentsType/TkSearchForm";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const steps = ["施設情報・職員情報", "届出内容確認", "機構へ提出"];

const searchFormList: TkSearchFormListItem[] = [
  {
    keyword: "name",
    label: "氏名",
    type: "label",
    inputProps: {
      maxLength: 48,
    },
  },
];

const searchFormSchema = {
  name: {
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0073E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "48"),
    },
  },
};

const infoHeadTitleList = [
  {
    headTitle: "氏名",
  },
  {
    headTitle: "生年月日",
  },
  {
    headTitle: "性別",
  },
  {
    headTitle: "加入日",
  },
];

export { steps, searchFormList, searchFormSchema, infoHeadTitleList };
